import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import CustomLink from '../CustomLink';
import { TERMS_OF_USE_LINK, PRIVACY_POLICY_LINK } from '../../shared/links';
import styles from './AgreementTextV5.css';

const cx = classnames.bind(styles);

function AgreementTextV5({ className, legalLinks = { privacyPolicy: PRIVACY_POLICY_LINK, termsOfUse: TERMS_OF_USE_LINK } }) {
    return (
        <p className={cx('agreementText', className)}>
            {'By continuing you agree to the '}
            <CustomLink
                to={legalLinks.termsOfUse}
                target='_blank'
            >
                Terms&nbsp;of&nbsp;Use
            </CustomLink>
            <br />
            {'and '}
            <CustomLink
                to={legalLinks.privacyPolicy}
                target='_blank'
            >
                Privacy&nbsp;Policy
            </CustomLink>
            .
        </p>
    );
}

AgreementTextV5.propTypes = {
    className: PropTypes.string,
    legalLinks: PropTypes.object
};

export {
    AgreementTextV5
};
